import {routerReducer as router} from 'react-router-redux';
import {combineReducers} from 'redux';
import {persistReducer} from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
import {createMemoryStorage} from 'storage-memory';
import {createFilter} from 'redux-persist-transform-filter';

import auth from './auth'
import navigation from './navigation';
import notifications from './notifications';
import settings from './settings';
import viewport from './viewport';

import {appReducers} from '../apps';

const reducers = combineReducers({
        ...appReducers,
        auth,
        navigation,
        notifications,
        settings,
        viewport,
        router
    }),
    storage = createMemoryStorage();

export default persistReducer({
    key: 'default',
    storage,
    whitelist: [
        'auth', 'settings'
    ],
    transforms: [
        createFilter('auth', ['access', 'refresh']),
        createFilter('settings', ['volume'])
    ]
}, reducers);


// WEBPACK FOOTER //
// ./src/reducers/index.js